import QRCode from "qrcode"

export const generateQRBase64 = async (text) => {
  try {
    return await QRCode.toDataURL(text)
  } catch (err) {
    console.error("Error generando QR:", err)
    return ""
  }
}